import { Link } from "react-router-dom";
import { getCategories } from "@/lib/news";

const catIcons: Record<string, string> = {
  娱乐: "ri-movie-2-line",
  时政: "ri-government-line",
  科技: "ri-cpu-line",
  社会: "ri-community-line",
  财经: "ri-line-chart-line",
  体育: "ri-basketball-line",
};

export default function CategoryQuickNav() {
  const categories = getCategories();

  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-5">
      <div className="mb-4 flex items-center gap-2">
        <span className="flex h-6 w-1.5 rounded-full bg-accent-500"></span>
        <h2 className="font-heading text-lg font-bold text-foreground-900">分类快捷入口</h2>
      </div>
      <div className="grid grid-cols-3 gap-2 sm:grid-cols-6 lg:grid-cols-3">
        {categories.map((cat) => (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group flex flex-col items-center gap-2 rounded-lg border border-background-200 py-4 transition-colors hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-11 w-11 items-center justify-center rounded-full bg-secondary-100 text-secondary-700 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
              <i className={`${catIcons[cat.name] || "ri-article-line"} text-xl`}></i>
            </span>
            <span className="text-sm font-medium text-foreground-800">{cat.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}